import styled from 'styled-components';

export const SelectedRegisterContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
`;

export const ContainerListSelectedRegister = styled.div`
  height: 100%;
  width: 100%;
`;
